module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-proreport"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.selfResult.avatar
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("你的动物画像专业报告")])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.funreport.basic_discription)
    }
  })]), _vm._v(" "), _c('div', {
    class: [_vm.funreport.key, 'position']
  }, [_c('div', {
    staticClass: "top t"
  }, [_vm._v("外向")]), _vm._v(" "), _c('div', {
    staticClass: "left t"
  }, [_vm._v("关系主导")]), _vm._v(" "), _c('div', {
    staticClass: "right t"
  }, [_vm._v("工作主导")]), _vm._v(" "), _c('div', {
    staticClass: "bottom t"
  }, [_vm._v("内向")]), _vm._v(" "), _c('img', {
    staticClass: "avatar",
    style: (_vm.funreport.coordinate),
    attrs: {
      "src": _vm.selfResult.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inPeopleEye"
  }, [_c('div', {
    class: ['onp', 'lovers', _vm.Onp.lovers ? 'open' : ''],
    on: {
      "click": function($event) {
        _vm.toggleOnp('lovers')
      }
    }
  }, [_c('div', {
    staticClass: "whom"
  }), _vm._v(" "), _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.funreport.in_lover)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('div', {
    class: ['onp', 'friends', _vm.Onp.friends ? 'open' : ''],
    on: {
      "click": function($event) {
        _vm.toggleOnp('friends')
      }
    }
  }, [_c('div', {
    staticClass: "whom"
  }), _vm._v(" "), _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.funreport.in_friends)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('div', {
    class: ['onp', 'colleague', _vm.Onp.colleague ? 'open' : ''],
    on: {
      "click": function($event) {
        _vm.toggleOnp('colleague')
      }
    }
  }, [_c('div', {
    staticClass: "whom"
  }), _vm._v(" "), _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.funreport.in_colleagues)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('div', {
    class: ['onp', 'parents', _vm.Onp.parents ? 'open' : ''],
    on: {
      "click": function($event) {
        _vm.toggleOnp('parents')
      }
    }
  }, [_c('div', {
    staticClass: "whom"
  }), _vm._v(" "), _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.funreport.will_be)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "yqd"
  }, [_c('ul', {
    staticClass: "tabs"
  }, [_c('li', {
    class: ['tab', 'youdian', _vm.Tab == 'youdian' ? 'show' : ''],
    on: {
      "click": function($event) {
        _vm.switchTab('youdian')
      }
    }
  }), _vm._v(" "), _c('li', {
    class: ['tab', 'quedian', _vm.Tab == 'quedian' ? 'show' : ''],
    on: {
      "click": function($event) {
        _vm.switchTab('quedian')
      }
    }
  }), _vm._v(" "), _c('li', {
    class: ['tab', 'jianyi', _vm.Tab == 'jianyi' ? 'show' : ''],
    on: {
      "click": function($event) {
        _vm.switchTab('jianyi')
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "tab_conts"
  }, [_c('li', {
    class: ['tab_cont', 'youdian', _vm.Tab == 'youdian' ? 'show' : ''],
    domProps: {
      "innerHTML": _vm._s(_vm.funreport.advantage)
    }
  }), _vm._v(" "), _c('li', {
    class: ['tab_cont', 'quedian', _vm.Tab == 'quedian' ? 'show' : ''],
    domProps: {
      "innerHTML": _vm._s(_vm.funreport.shortcoming)
    }
  }), _vm._v(" "), _c('li', {
    class: ['tab_cont', 'jianyi', _vm.Tab == 'jianyi' ? 'show' : ''],
    domProps: {
      "innerHTML": _vm._s(_vm.funreport.suggest)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "jobs"
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.funreport.match_jobs))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "toFunreport"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.toFunreport()
      }
    }
  }, [_vm._v("趣味报告点这里")])]), _vm._v(" "), _c('yxl-logo')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/funreport-qrcode.png"),
      "alt": "qrcode"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-c03bd930!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/proreport.vue
// module id = 137
// module chunks = 2